<template>
    <ModalBase
        :name="'borrar-codigo-' + codigo.id"
        :title="'Borrar código de invitación'"
        @close="close"
    >
        <div class="tw:space-y-6">
            <div>
                <p class="tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wider tw:text-gray-400 tw:mb-3">Datos del código</p>
                <div class="tw:grid tw:grid-cols-2 tw:gap-4">
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Código</p>
                        <p class="tw:font-mono tw:text-sm tw:text-gray-900">{{ codigo.codigo }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Usos</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ codigo.usos }}</p>
                    </div>
                </div>
            </div>

            <div class="tw:rounded-lg tw:border tw:border-amber-200 tw:bg-amber-50 tw:p-3 tw:text-sm tw:text-amber-800">
                <i class="fas fa-exclamation-triangle tw:mr-1"></i>
                ¿Estás segur@ de borrar este código? Esta acción no se puede deshacer.
            </div>
        </div>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="ghost" @click="close" :disabled="loading">Cancelar</Button>
                <Button variant="danger" @click="handleConfirm" :loading="loading">SI, BORRAR</Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, getCurrentInstance } from 'vue';
    import store from '@/store';
    import { config } from '@/config.js';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import { useToast } from '@/composables/common/useToast';

    const props = defineProps({
        codigo: { type: Object, required: true },
        listaId: { type: [String, Number], required: true },
        categoriaId: { type: [String, Number], required: true }
    });

    const emit = defineEmits(['close', 'borrado']);
    const instance = getCurrentInstance();
    const toast = useToast();
    const loading = ref(false);

    function close() {
        instance.proxy.$modal.hide('borrar-codigo-' + props.codigo.id);
        emit('close');
    }

    async function handleConfirm() {
        loading.value = true;
        try {
            await store.dispatch(
                config.getVuexAlias('back.bases.categorias.codigos_invitacion.borrar'),
                {
                    lista_id: props.listaId,
                    categoria_id: props.categoriaId,
                    codigo_id: props.codigo.id
                }
            );
            toast.success('Código eliminado correctamente.');
            emit('borrado');
            close();
        } catch (error) {
            console.error('Error deleting codigo:', error);
            toast.error(error.response?.data?.message || 'Error al eliminar el código');
        } finally {
            loading.value = false;
        }
    }
</script>
